import { HashRouter as Router } from 'react-router-dom';

import { StyleWrapper } from './styleWrapper';
import { CssVariables } from './globalStyle';
import { BrandWrapper } from './brandWrapper';
import { HelmetProvider } from 'react-helmet-async';
import { ScrollToTop } from '../../routes/parts/useScrollToTop';

// global font-awesome icon style overrides
import './icons.css';
// global css variables
import './variables.css';

export const App = () => (
  <HelmetProvider>
    <Router>
      <ScrollToTop />
      <BrandWrapper>
        <CssVariables />
        <StyleWrapper />
      </BrandWrapper>
    </Router>
  </HelmetProvider>
);
